import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';
import { AsmService } from '../../../../services/asm/asm.service';
import { TranslocoModule } from '@ngneat/transloco';
import { IPAddress, ScanHistory } from '../../../../interfaces/asm/models';
import { QueryIpsResponse } from '../../../../interfaces/asm/QueryIpsResponse';

@Component({
    selector: 'app-ip-addresses',
    standalone: true,
    imports: [MatCardModule, TranslocoModule],
    templateUrl: './ip-addresses.component.html',
    styleUrl: './ip-addresses.component.scss',
})
export class IpAddressesComponent {
    // isToggled
    isToggled = false;

    @Input() scan: ScanHistory;
    data: IPAddress[] = [];

    constructor(
        public themeService: CustomizerSettingsService,
        private asmService: AsmService
    ) {
        this.themeService.isToggled$.subscribe((isToggled) => {
            this.isToggled = isToggled;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // changeData
    changeData() {
        this.asmService
            .getQueryIps(this.scan.id)
            .subscribe((response: QueryIpsResponse) => {
                this.data = response.ips;
            });
    }
}
